/* global axios */
import ApiClient from './ApiClient';

class GoalsAPI extends ApiClient {
  constructor() {
    super('goals', { accountScoped: true });
  }

  getGoals(userId) {
    return axios.get(this.url, { params: { user_id: userId } });
  }

  create(data) {
    return axios.post(this.url, data);
  }

  sync(userId, goals) {
    return axios.post(`${this.url}/sync`, {
      user_id: userId,
      goals,
    });
  }

  destroy(goalId) {
    return axios.delete(`${this.url}/${goalId}`);
  }
}

export default new GoalsAPI();
